import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';

@Component({
  selector: 'app-cookie-message',
  templateUrl: './app-cookie-message.component.html',
  styleUrls: ['./app-cookie-message.component.css']
})
export class AppCookieMessageComponent implements OnInit {

  _cookieMessageHidden: boolean;

  constructor(
    private router: Router,
    private _cookieService: CookieService,
    private _shopSettingsService: ShopSettingsService,
  ) { }

  ngOnInit(): void {
  }

  get cookieMessageHidden(): boolean {
    if (this._shopSettingsService.isVUMode || this._cookieService.get('msg_cookies_use')) {
      this._cookieMessageHidden = true;
    } else {
      this._cookieMessageHidden = false;
    }
    return this._cookieMessageHidden;
  }

  onPrivacyPolicyClick(): void {
    this.router.navigateByUrl('privacy');
  }

  closeCookie(): void {
    const now = new Date();
    const nextMonth = new Date(now.setDate(now.getDate() + 30));
    this._cookieService.put('msg_cookies_use', 'true', { 'expires': nextMonth });
  }

}
